module.exports = __webpack_public_path__ + "static/img/wap_banner.7cca115.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/about/wap_banner.png
// module id = yBpH
// module chunks = 17